import { useMemo, useState } from "react";
import { makeDefaultWall, fmt } from "@tasduvar/engine";
import { t } from "../../i18n";
import { runAnalysis } from "../../state/useAnalysis";
import { SectionDrawing, DEFAULT_LAYERS, type Layers } from "../drawing/SectionDrawing";
import { Forces } from "../drawing/layers/Forces";
import { BasePressure } from "../drawing/layers/BasePressure";

/** Ana sayfadaki "pafta": varsayılan duvarın canlı kesiti + antet şeridi. Süs değil, ürünün ilk ekranda gösterdiği şey. */
export function HeroSheet(): JSX.Element {
  // Varsayılan duvarın biraz geniş tabanlısı: ilk ekranda sağlayan bir kesit görünsün
  const wall = useMemo(() => { const w = makeDefaultWall(t("Örnek duvar")); if (w.geometry.mode === "parametric") w.geometry.steps[0]!.bottomThickness = 2.4; w.foundationSoil.baseFriction = { mode: "phi" }; w.seismic.enabled = false; return w; }, []);
  const a = useMemo(() => runAnalysis(wall), [wall]);
  const [layers, setLayers] = useState<Layers>({ ...DEFAULT_LAYERS, joints: false });
  const r = a.result;
  const st = r?.cases.static;
  return (
    <figure className="sheet rounded-none p-0 overflow-hidden" aria-label={t("Örnek kesit paftası")}>
      <div className="relative h-[340px] md:h-[380px] bg-sheet">
        <SectionDrawing wall={wall} result={r} error={a.error} layers={layers} onLayers={setLayers} hideLayerBar>
          {(tr) => r ? (<>{layers.base ? <BasePressure t={tr} result={r} caseId="static" /> : null}{layers.forces ? <Forces t={tr} result={r} caseId="static" /> : null}</>) : null}
        </SectionDrawing>
      </div>
      <figcaption className="grid grid-cols-2 md:grid-cols-4 border-t border-ink text-xs">
        {[
          [t("Kesit"), `H = ${fmt(r?.geometry.yTop ?? 0, 2)} m · B = ${fmt(r?.geometry.B ?? 0, 2)} m`],
          [t("Yönetmelik"), "TBDY 2018 §16.12"],
          [t("Devrilme GK"), st ? fmt(st.overturning.classic.factor, 2) : "—"],
          [t("Kayma GK"), st ? fmt(st.sliding.classic.factor, 2) : "—"],
        ].map(([k, v], i) => (
          <div key={k} className={`px-3 py-2 border-ink/60 ${i % 2 === 1 ? "border-l" : ""} ${i >= 2 ? "border-t md:border-t-0 md:border-l" : ""}`}>
            <div className="text-stone">{k}</div>
            <div className="num text-ink">{v}</div>
          </div>
        ))}
      </figcaption>
    </figure>
  );
}
